import * as traverse from 'traverse'
import { randomInt } from './random'

// Remove empty values and circular references
export function scrubValues(obj: {}): {} {
  return traverse(obj).map(function(val: any) {
    if (this.circular || [null, undefined].indexOf(val) !== -1) {
      this.remove()
    }
  })
}

export const getRandomObjectKey = (obj: object): string => {
  const keys = Object.keys(obj)
  const bottomOfRange = 0
  const topOfRange = keys.length - 1

  return keys[randomInt(bottomOfRange, topOfRange)]
}
